import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";
import {
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Spin,
  Switch,
  Table,
  notification,
} from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useMutation, useLazyQuery } from "@apollo/client";
import { GET_ALL_PRINTERS } from "../../Apollo/graphql/Query";
import {
  DELETE_PRINTER,
  EDIT_PRINTER,
} from "../../Apollo/graphql/Mutation/PrintersMutations";
import { AlignType } from "rc-table/lib/interface";
import { useHistory } from "react-router-dom";
import { replaceError } from "../../utils/utilsFunctions";

const { Option } = Select;

const PrinterContainer = styled(Col)`
  .singlePrinterImageCol {
    cursor: pointer;
  }
`;
const BoxImage = styled.img`
  height: inherit;
  max-height: 100px;
  width: auto;
`;
const FilamentsDiv = styled.div`
  border: 1px solid black;
  padding: 1rem 2rem;
  .text {
    padding-bottom: 1rem;
    font-size: 20px;
  }
`;
const CheckGroupBox = styled.div``;

const PrinterLists: FC = () => {
  const history = useHistory();
  const [printers, setPrinters] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const [editPrinter, setEditPrinter] = useState<any>({});
  const [totalPage, setTotalPage] = useState<any>();
  const [currentPage, setCurrentPage] = useState<any>(1);
  const [filterValue, setFilterValue] = useState<any>([]);
  const [selectedMaterial, setSelectedMaterial] = useState<any>([]);
  const [sortValue, setSortValue] = useState<any>();
  const PAGE_LIMIT = 10;

  const [getPrinters, { loading, data }] = useLazyQuery(GET_ALL_PRINTERS, {
    onCompleted: (data) => {
      setPrinters(data?.printers?.printers);
      setTotalPage(data?.printers?.pagination?.total);
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });
  useEffect(() => {
    const variables = {};
    variables["pagination"] = {
      page: currentPage,
      limit: PAGE_LIMIT,
    };
    if (filterValue?.length > 0) {
      variables["filter"] = {
        material: filterValue,
      };
    }
    if (sortValue === "popular") {
      variables["sort"] = {
        popularity: "desc",
      };
    }
    getPrinters({ variables: { ...variables } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, sortValue, currentPage]);

  const columns: any = [
    {
      title: "Thumbnail of Main Printer Image",
      dataIndex: "",
      key: "featuredImage",
      align: "center" as AlignType,
      width: "200px",
      render: (record: any) => {
        return (
          <BoxImage
            className="singlePrinterImageCol"
            src={record.featuredImage}
            alt=""
            onClick={() => history.push(`/printers/${record._id}`)}
          />
        );
      },
    },
    {
      title: "Materials & Price/Gram",
      dataIndex: "",
      key: "",
      width: "150px",
      align: "center" as AlignType,
      render: (record: any) => {
        return record.filaments.map((s) => {
          return (
            <div>
              {`${
                s?.name === "PLA_PLUS" ? "PLA+" : s?.name.replaceAll("_", " ")
              } - Au$ ${s?.price}`}
              <br />
            </div>
          );
        });
      },
    },
    {
      title: "Printer Model",
      dataIndex: "",
      key: "",
      align: "center" as AlignType,
      render: (record: any) => {
        return `${record.name} ${record.brand}`;
      },
    },
    {
      title: "Print Size Supported(mm)",
      dataIndex: "",
      key: "",
      align: "center" as AlignType,
      width: "200px",
      render: (record: any) => {
        return record.length + "x" + record.height + "x" + record.width;
      },
    },
    {
      title: "Rating",
      dataIndex: "averageStarRating",
      key: "rating",
      align: "center" as AlignType,
    },
    {
      title: "Status",
      dataIndex: "",
      key: "active",
      align: "center" as AlignType,
      render: (record: any) => {
        return `${record.active === true ? "Active" : "Inactive"}`;
      },
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      width: "150px",
      align: "center" as AlignType,
      render: (record: any) => {
        return (
          <>
            <EditOutlined
              onClick={() => onEditPrinter(record)}
              style={{ color: "green", fontSize: "20px", padding: "4px" }}
            />
            <DeleteOutlined
              onClick={() => onDeletePrinter(record)}
              style={{
                color: "red",
                marginLeft: "1rem",
                fontSize: "24px",
                padding: "4px",
              }}
            />
          </>
        );
      },
    },
  ];
  const [editPrinterMutation] = useMutation(EDIT_PRINTER, {
    refetchQueries: [{ query: GET_ALL_PRINTERS }],
  });

  const [deletePrinterMutation] = useMutation(DELETE_PRINTER, {
    refetchQueries: [{ query: GET_ALL_PRINTERS }],
  });
  const onDeletePrinter = (record: any) => {
    Modal.confirm({
      title: "Are you sure to delete this printer? All orders related to this printer may appear empty.",
      okText: "Yes",
      okType: "danger",
      onOk: () => {
        deletePrinterMutation({
          variables: {
            printerId: record._id,
          },
        });
      },
    });
  };
  const onEditPrinter = (record: any) => {
    setIsEditing(true);
    setEditPrinter({ ...record });
  };
  const resetPrinter = () => {
    setIsEditing(false);
    setEditPrinter({});
  };
  const onCheckboxChange = (e: any) => {
    setSelectedMaterial(e);
    setFilterValue(e);
  };
  const onChange = (value: string) => {
    console.log(`selected ${value}`);
  };

  return (
    <Spin spinning={loading}>
      <PrinterContainer>
        {data && (
          <Table
            bordered
            title={() => (
              <div
                style={{
                  display: "flex",
                  flexFlow: "row",
                  justifyContent: "space-between",
                }}
              >
                <Select
                  placeholder={
                    selectedMaterial?.length !== 0
                      ? `${selectedMaterial?.toString()}`
                      : `All`
                  }
                  onChange={onChange}
                  dropdownMatchSelectWidth={false}
                  dropdownRender={() => (
                    <CheckGroupBox>
                      <Checkbox.Group
                        onChange={onCheckboxChange}
                        defaultValue={selectedMaterial}
                      >
                        <Space
                          direction="vertical"
                          style={{ padding: "0 10px" }}
                        >
                          <Checkbox value="ABS">ABS</Checkbox>
                          <Checkbox value="PLA">PLA</Checkbox>
                          <Checkbox value="PLA_PLUS">PLA+</Checkbox>
                          <Checkbox value="PET">PET</Checkbox>
                          <Checkbox value="PETG">PETG</Checkbox>
                          <Checkbox value="RESIN">RESIN</Checkbox>
                          <Checkbox value="NYLON">NYLON</Checkbox>
                          <Checkbox value="NYLON_CARBON_FIBER">
                            NYLON CARBON FIBER
                          </Checkbox>
                          <Checkbox value="TPU">TPU</Checkbox>
                          <Checkbox value="HIPS">HIPS</Checkbox>
                          <Checkbox value="PVA">PVA</Checkbox>
                          <Checkbox value="SANDSTONE">SANDSTONE</Checkbox>
                          <Checkbox value="CERAMICS">CERAMICS</Checkbox>
                          <Checkbox value="STEEL">STEEL</Checkbox>
                          <Checkbox value="WOOD">WOOD</Checkbox>
                          <Checkbox value="POLYCARBONATE">
                            POLYCARBONATE
                          </Checkbox>
                        </Space>
                      </Checkbox.Group>
                    </CheckGroupBox>
                  )}
                ></Select>
                <Select
                  placeholder={"Sort By"}
                  dropdownMatchSelectWidth={false}
                  onChange={(value) => setSortValue(value)}
                >
                  <Option value="popular">Popular</Option>
                  <Option value="recent">Recent</Option>
                </Select>
              </div>
            )}
            columns={columns}
            dataSource={printers}
            pagination={{
              position: ["bottomCenter"],
              current: currentPage,
              total: totalPage,
              showSizeChanger: false,
              defaultPageSize: PAGE_LIMIT,
              onChange: (page) => {
                setCurrentPage(page);
              },
            }}
            scroll={{ x: true, scrollToFirstRowOnChange: true }}
            rowClassName="singlePrinterRow"
          ></Table>
        )}
        <Modal
          title="Edit Printer --"
          okText="Save"
          visible={isEditing}
          onCancel={() => {
            resetPrinter();
          }}
          onOk={async () => {
            try {
              await editPrinterMutation({
                variables: {
                  printerId: editPrinter._id,
                  input: {
                    active: editPrinter.active,
                  },
                },
              });
            } catch (err) {
              notification.error({
                message: "Error",
                description: replaceError(err),
              });
            }

            resetPrinter();
          }}
        >
          <Form>
            <Form.Item label="Name">
              <Input
                value={editPrinter?.name}
                disabled
                onChange={(e) => {
                  setEditPrinter((pre) => {
                    return { ...pre, name: e.target.value };
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Brand">
              <Input
                value={editPrinter?.brand}
                disabled
                onChange={(e) => {
                  setEditPrinter((pre) => {
                    return { ...pre, brand: e.target.value };
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="length">
              <Input
                type="number"
                disabled
                value={editPrinter?.length}
                onChange={(e) => {
                  setEditPrinter((pre) => {
                    return { ...pre, length: Number(e.target.value) };
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Height">
              <Input
                type="number"
                value={editPrinter?.height}
                disabled
                onChange={(e) => {
                  setEditPrinter((pre) => {
                    return { ...pre, height: Number(e.target.value) };
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Width">
              <Input
                type="number"
                disabled
                value={editPrinter?.width}
                onChange={(e) => {
                  setEditPrinter((pre) => {
                    return { ...pre, width: Number(e.target.value) };
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="weight">
              <Input
                type="number"
                disabled
                value={editPrinter?.weight}
                onChange={(e) => {
                  setEditPrinter((pre) => {
                    return { ...pre, weight: Number(e.target.value) };
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Switch
                checkedChildren="active"
                unCheckedChildren="inactive"
                defaultChecked={editPrinter?.active}
                onChange={(e) => {
                  setEditPrinter((pre) => {
                    return { ...pre, active: e };
                  });
                }}
              />
            </Form.Item>
            <Form.Item label="Location" name="location">
              <Select disabled placeholder={editPrinter?.postalAddress}>
                <Option value="australia">Australia</Option>
              </Select>
            </Form.Item>
            <FilamentsDiv>
              <div className="text">Filament and material:</div>
              {editPrinter?.filaments &&
                editPrinter?.filaments.map((s, idx) => {
                  return (
                    <div key={idx}>
                      <Form.Item label="Material" name="material">
                        <Select
                          disabled
                          placeholder={s.name}
                          defaultValue={s.name}
                        >
                          <Option value="1">1</Option>
                        </Select>
                      </Form.Item>
                      <Form.Item label="Price" name="price">
                        <Input
                          placeholder={s.price}
                          disabled
                          // defaultValue={}
                        />
                      </Form.Item>
                      <Form.Item label="Colors" name="colors">
                        <Select disabled placeholder={s.colors.toString()}>
                          <Option value="1">1</Option>
                        </Select>
                      </Form.Item>
                    </div>
                  );
                })}
            </FilamentsDiv>
          </Form>
        </Modal>
      </PrinterContainer>
    </Spin>
  );
};

export default PrinterLists;
